<script setup lang="ts">
import InputBase from '../../ui/input-text/InputBase.vue';
import DropdownBase from './DropdownBase.vue';

import { ref } from 'vue';

interface IDropdownOption {
  value: string | number;
}

const props = defineProps<{
  options?: IDropdownOption[];
  modelValue?: IDropdownOption;
  queryStr: string;
  placeholder?: string;
  error?: string;
  label?: string;
  isRequired?: boolean;
  emptyMessage?: string;
  isLoading?: boolean;
  isHideAfterSelectEnabled?: boolean;
  disabled?: boolean;
  isEmptyOptionsShown?: boolean;
  container?: any;
}>();

const emit = defineEmits<{
  (e: 'update:modelValue', value: IDropdownOption, hideFn: () => void): void;
  (e: 'update:queryStr', value: string): void;
  (e: 'hide'): void;
  (e: 'show'): void;
  (e: 'focus'): void;
}>();

const inputBaseEl = ref();

function onButtonClick() {
  inputBaseEl.value?.focus();
}

function onInputClick(e: Event, showFn: () => void) {
  e.stopPropagation();
  showFn();
  inputBaseEl.value?.focus();
}
</script>

<template>
  <DropdownBase
    v-bind="props"
    no-auto-focus
    :class="{ 'dropdown-input_disabled': disabled }"
    @update:modelValue="(value, hideFn) => $emit('update:modelValue', value, hideFn)"
    @buttonClick="onButtonClick"
    @hide="$emit('hide')"
    @show="$emit('show')"
  >
    <template #button="{ show, hide }">
      <InputBase
        ref="inputBaseEl"
        :model-value="queryStr"
        :placeholder="placeholder"
        @update:model-value="(value) => (show(), $emit('update:queryStr', value))"
        @focus="$emit('focus')"
        @click="onInputClick($event, show)"
        @keydown.enter="(hide(), $emit('update:modelValue', options[0]))"
      />
    </template>

    <template #option="{ option }">
      <slot name="option" :option="option" />
    </template>

    <template #options-prepend>
      <slot name="options-prepend" />
    </template>
  </DropdownBase>
</template>

<style lang="stylus" scoped>
.dropdown-input
  &_disabled
    pointer-events none
</style>
